export default __webpack_public_path__ + "static/media/cloud.4e08a20c.svg";